export enum AadErrorCode {
  SsoArtifactExpiredDueToConditionalAccess = "70044",
}
